export default __webpack_public_path__ + "static/summer_containers98-8a7875bf5a2dc987a80b701701105ace.webp";